export const THANK_YOU_MODAL = 'thankYouModal';
export const CONTACT_US_MODAL = 'contactUsModal';
export const FULL_SIZE_IMAGE_MODAL = 'fullSizeImageModal';

const modals: {
  THANK_YOU_MODAL: typeof THANK_YOU_MODAL;
  CONTACT_US_MODAL: typeof CONTACT_US_MODAL;
  FULL_SIZE_IMAGE_MODAL: typeof FULL_SIZE_IMAGE_MODAL;
} = {
  THANK_YOU_MODAL,
  CONTACT_US_MODAL,
  FULL_SIZE_IMAGE_MODAL,
};

export default modals;
